import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const MarketTreeMapStyle = makeStyles((theme: Theme) =>
  createStyles({
    container: { display: "flex", justifyContent: "center" },
    title: {
      color: theme.palette.text.primary, //text color
      fontFamily: theme.typography.fontFamily,
      fontSize: "35px",
      fontWeight: theme.typography.fontWeightBold,
      textTransform: "capitalize",
      display: "flex",
      justifyContent: "start",
      paddingTop: "10px",
      marginBottom: "30px",

      [theme.breakpoints.down("sm")]: {
        fontSize: "1.5em;",
      },
    },

    drawToggle: {},
    titlePartB: {
      color: theme.palette.secondary.main,
      fontFamily: theme.typography.fontFamily,
      fontSize: "35px",
      fontWeight: theme.typography.fontWeightBold,
      textTransform: "capitalize",
      display: "flex",
      justifyContent: "start",
      paddingTop: "10px",
      marginBottom: "30px",

      [theme.breakpoints.down("sm")]: {
        fontSize: "1.5em;",
      },
    },

    drawerTitle: {
      color: theme.palette.primary.main,
      fontFamily: theme.typography.fontFamily,
      fontSize: "30px",
      fontWeight: theme.typography.fontWeightBold,
      textTransform: "capitalize",
      marginBottom: "10px",
      marginTop: "10px",

      [theme.breakpoints.down("sm")]: {
        fontSize: "1.5em;",
      },
    },
    drawer: {
      paper: {
        background: "blue",
      },
    },
    subTitle: { marginBottom: "30px" },
    toolBar: {
      height: "80px",
      [theme.breakpoints.up("md")]: {
        height: "20px",
      },
    },
    treemapLegend: {
      width: "400px",
      [theme.breakpoints.down("md")]: {
        width: "300px",
      },
      [theme.breakpoints.down("sm")]: {
        width: "100%",
      },
    },
    chipHide: {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      fontWeight: 700,
      marginRight: "10px",
      height: "20px",
      marginBottom: "10px",
      "&:hover": { backgroundColor: theme.palette.secondary.main },
    },
    hideSelect: {
      verticalAlign: "middle",
    },
    menuDropDown: {
      "&.Mui-selected": {
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
      },
    },
    filterTools: {},
    iconButtons: {
      height: "30px",
      display: "flex",
      width: "20px",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      [theme.breakpoints.down("sm")]: {
        height: "50px",
      },
    },
    dropDownMenuItem: {
      "&:hover": { backgroundColor: "#fff" },
    },
    slider: { marginTop: 2 },
  }),
);
